"use strict";
import Api from "../../api/api";
const TrainingEnvironmentNavigation = React.createClass({
  propTypes: {
    showLessonToC: React.PropTypes.func.isRequired,
    showVideoCallback: React.PropTypes.func.isRequired,
    accountId: React.PropTypes.number.isRequired,
    lesson: React.PropTypes.object,
    trainingUserToken: React.PropTypes.string,
    allLessonsCompleted: React.PropTypes.bool.isRequired,
    loading: React.PropTypes.bool.isRequired
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "training-banner" }, /* @__PURE__ */ React.createElement("div", { className: "training-banner__left" }, /* @__PURE__ */ React.createElement("div", { className: "training-banner__header" }, /* @__PURE__ */ React.createElement("div", { className: "training-banner__header-controls" }, /* @__PURE__ */ React.createElement(
      "a",
      {
        className: "training-banner__link",
        onClick: this.viewTableOfContents
      },
      /* @__PURE__ */ React.createElement("i", { className: "fi-list" }),
      /* @__PURE__ */ React.createElement("span", { className: "link__has-icon--left" }, "All Lessons")
    ))), /* @__PURE__ */ React.createElement("div", { className: "training-banner__header-content" }, /* @__PURE__ */ React.createElement("h3", { className: "training-banner__title" }, this.lessonTitle()), /* @__PURE__ */ React.createElement("div", { className: "training-banner__controls" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "training-banner__button",
        onClick: this.viewVideoGuide
      },
      /* @__PURE__ */ React.createElement("i", { className: "icon-video fi-video" }),
      /* @__PURE__ */ React.createElement("span", { className: "button__has-icon--left" }, "Guide")
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "training-banner__button",
        onClick: this.completeLesson
      },
      "Done with lesson"
    )))), /* @__PURE__ */ React.createElement("div", { className: "training-banner__content-box" }, /* @__PURE__ */ React.createElement("p", null, this.lessonDescription())), /* @__PURE__ */ React.createElement("div", { className: "training-banner__content-box" }, /* @__PURE__ */ React.createElement("p", null, "This account is currently in training mode."), /* @__PURE__ */ React.createElement("p", null, "No invoices or emails will be sent to external systems.")));
  },
  lessonTitle() {
    if (this.props.loading) {
      return "...";
    } else if (this.props.allLessonsCompleted) {
      return "All Lessons Completed!";
    } else {
      return this.props.lesson.title;
    }
  },
  lessonDescription() {
    if (this.props.loading) {
      return "";
    } else if (this.props.allLessonsCompleted) {
      return "Great work! Thanks for completing our training!";
    } else {
      return this.props.lesson.description;
    }
  },
  viewTableOfContents() {
    this.props.showLessonToC(true);
  },
  viewVideoGuide() {
    this.props.showVideoCallback(true);
  },
  completeLesson(_) {
    Api.TrainingEnvironment.completeLesson(this.props.accountId, this.props.trainingUserToken);
  },
  restartLesson(e) {
  }
});
export default TrainingEnvironmentNavigation;
